import React, { useState, useContext } from "react";
import Input from "../../shared/components/Input";
import {
	VALIDATOR_NUMBER_ONLY,
	VALIDATOR_REQUIRE,
} from "../../shared/util/validators";
import useForm from "../../shared/hooks/form-hooks";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { AuthContext } from "../../context/AuthContext";
import { CircularProgress } from "@mui/material";
import { baseUrl } from "../../baseUrl";

const OrderTypeSubmit = () => {
	const [isLoading, setIsLoading] = useState(false);
	const auth = useContext(AuthContext);
	const { enqueueSnackbar } = useSnackbar();
	const dispatch = useDispatch();

	const [formState, inputHandler] = useForm(
		{
			name: {
				value: "",
				isValid: false,
			},
			unitPrice: {
				value: "",
				isValid: false,
			},
			oneJawPrice: {
				value: "",
				isValid: false,
			},
			twoJawPrice: {
				value: "",
				isValid: false,
			},
		},
		false
	);
	const orderTypeHandler = async (event) => {
		event.preventDefault();

		try {
			setIsLoading(true);
			const response = await fetch(
				baseUrl + "/api/v1/laboratorys/create-orderType",
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						authorization: auth.token,
					},
					body: JSON.stringify({
						name: formState.inputs.name.value,
						perUnitPrice: formState.inputs.unitPrice.value,
						jawPrice: formState.inputs.oneJawPrice.value,
						twoJawPrice: formState.inputs.twoJawPrice.value,
					}),
				}
			);
			const responseData = await response.json();
			if (!response.ok) {
				throw new Error(responseData.message);
			} else {
				enqueueSnackbar(responseData.message.message, {
					variant: "success",
				});
			}
			setIsLoading(false);
			dispatch({
				type: "update_order_types",
			});
		} catch (err) {
			setIsLoading(false);
			err &&
				err.data.forEach((error) =>
					enqueueSnackbar(error, { variant: "error" })
				);
		}
	};

	return (
		<React.Fragment>
			<Paper sx={{ flexGrow: 1, maxWidth: 1200, p: 2 }}>
				<Typography variant="h5" align="center" sx={{ mb: 5 }}>
					ثبت نوع کار
				</Typography>
				{isLoading ? (
					<div style={{ justifyContent: "center", display: "flex" }}>
						<CircularProgress color="inherit" />
					</div>
				) : (
					<form onSubmit={orderTypeHandler}>
						<Grid container spacing={2}>
							<Grid md={3} xs={6}>
								<Input
									id="name"
									element="input"
									validators={[VALIDATOR_REQUIRE()]}
									errorText="لطفا وارد کنید."
									onInput={inputHandler}
									label="نام"
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="unitPrice"
									element="number_only"
									label="قیمت هر واحد"
									validators={[
										VALIDATOR_REQUIRE(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									errorText="لطفاعدد وارد کنید."
									onInput={inputHandler}
									type="text"
									needsThousandSeparator
									inputProps={{
										min: 0,
									}}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="oneJawPrice"
									element="number_only"
									label="قیمت یک فک"
									validators={[
										VALIDATOR_REQUIRE(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									errorText="لطفاعدد وارد کنید."
									onInput={inputHandler}
									type="text"
									needsThousandSeparator
									inputProps={{
										min: 0,
									}}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="twoJawPrice"
									element="number_only"
									label="قیمت دو فک"
									validators={[
										VALIDATOR_REQUIRE(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									errorText="لطفاعدد وارد کنید."
									onInput={inputHandler}
									type="text"
									needsThousandSeparator
									inputProps={{
										min: 0,
									}}
								/>
							</Grid>
							<Grid xs={12} sm={12}>
								<Button
									type="submit"
									disabled={!formState.isValid}
									fullWidth
									color="secondary"
									variant="contained"
								>
									ثبت نوع کار
								</Button>
							</Grid>
						</Grid>
					</form>
				)}
			</Paper>
		</React.Fragment>
	);
};

export default OrderTypeSubmit;
